import { render, staticRenderFns } from "./LetterBlack.vue?vue&type=template&id=02a30e90&scoped=true"
var script = {}
import style0 from "./LetterBlack.vue?vue&type=style&index=0&id=02a30e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a30e90",
  null
  
)

export default component.exports